import { v4 } from 'uuid';

export const getUuid = () => v4();
